import { HttpParams } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';
import { ApiService } from '../../shared/services/core/api.service';
import { MemberQuery } from '../../account/member/member.query';
import { catchError, firstValueFrom, Observable, shareReplay, throwError } from 'rxjs';

interface CustomerContent {
  Notifications: Notification;
}

interface Notification {
  UnseenNotifications: number;
  UnRedeemedRewardsCount: number;
}

@Injectable({ providedIn: 'root' })
export class UnredeemedCountService {
  private request$: Observable<CustomerContent> | null = null;
  private _unredeemedWalletCount = signal<number>(0);
  unredeemedWalletCount = computed(this._unredeemedWalletCount);

  constructor(
    private apiService: ApiService,
    private memberQuery: MemberQuery
  ) {}

  /**
   * Load the service with the unredeemed wallet count from the API
   */
  fetchUnredeemedWalletCount() {
    if (this._unredeemedWalletCount()) {
      return;
    }

    if (!this.request$) {
      const context = this.memberQuery.getUserContext();
      const params = new HttpParams().set('portalId', context.portalId).set('clubId', context.clubId);

      this.request$ = this.apiService.getAnySingle<CustomerContent>('content/customer?' + params.toString()).pipe(
        shareReplay({ bufferSize: 1, refCount: true }),
        catchError((error) => {
          this.request$ = null;
          return throwError(() => error);
        })
      );
    }

    firstValueFrom(this.request$).then((result) => {
      const resultCount = result.Notifications.UnRedeemedRewardsCount;

      if (this.unredeemedWalletCount() != resultCount) {
        this._unredeemedWalletCount.set(resultCount);
      }
    });
  }
}
